import React from 'react';
import PaymentVerification from '../components/PaymentVerification';

const PaymentManagement = () => {
  return (
    <div>
      <PaymentVerification />
    </div>
  );
};

export default PaymentManagement;